var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarouselLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 23.146H9C3.57 23.146 1.25 20.8305 1.25 15.4109V9.42246C1.25 4.00291 3.57 1.68738 9 1.68738H15C20.43 1.68738 22.75 4.00291 22.75 9.42246V15.4109C22.75 20.8305 20.43 23.146 15 23.146ZM9 3.18449C4.39 3.18449 2.75 4.82133 2.75 9.42246V15.4109C2.75 20.012 4.39 21.6489 9 21.6489H15C19.61 21.6489 21.25 20.012 21.25 15.4109V9.42246C21.25 4.82133 19.61 3.18449 15 3.18449H9Z",
    fill: "#4CB3D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2599 16.6885C13.0699 16.6885 12.8799 16.6186 12.7299 16.4689L9.19992 12.9457C8.90992 12.6563 8.90992 12.1772 9.19992 11.8877L12.7299 8.36454C13.0199 8.0751 13.4999 8.0751 13.7899 8.36454C14.0799 8.65398 14.0799 9.13306 13.7899 9.4225L10.7899 12.4167L13.7899 15.411C14.0799 15.7004 14.0799 16.1795 13.7899 16.4689C13.6499 16.6186 13.4599 16.6885 13.2599 16.6885Z",
    fill: "#4CB3D3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarouselLeft);
export default __webpack_public_path__ + "static/media/carousel_left.c878e85a.svg";
export { ForwardRef as ReactComponent };